import { render, staticRenderFns } from "./productvarietydetails.vue?vue&type=template&id=38112390&scoped=true&"
import script from "./productvarietydetails.vue?vue&type=script&lang=js&"
export * from "./productvarietydetails.vue?vue&type=script&lang=js&"
import style0 from "./productvarietydetails.vue?vue&type=style&index=0&id=38112390&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38112390",
  null
  
)

export default component.exports